
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-methods",
      function () {
        return require("private-next-pages/payment-methods.jsx");
      }
    ]);
  